export default {
      id: "oc-oraclecloud-usage",
      viewBox: "0 0 42 26",
      url: __webpack_public_path__ + "sprite.svg#oc-oraclecloud",
      toString: function () {
        return this.url;
      }
    }